export default [
    {
        title: 'Overblik',
        route: 'home',
        icon: 'HomeIcon',
        resource: 'Client',
        action: 'read',
    },
    // {
    //     title: 'Ordrer',
    //     route: 'orders',
    //     icon: 'ShoppingCartIcon',
    //     resource: 'Client',
    //     action: 'read',
    // },
    // {
    //     title: 'Kunder',
    //     route: 'customers',
    //     icon: 'UsersIcon',
    //     resource: 'Client',
    //     action: 'read',
    // },
    {
        title: 'Produkter',
        route: 'products',
        icon: 'TagIcon',
        resource: 'Client',
        action: 'read',
    },
    {
        title: 'Lager',
        route: 'stock',
        icon: 'ArchiveIcon',
        resource: 'Client',
        action: 'read',
    },
    // {
    //     title: 'Kategorier',
    //     route: 'categories',
    //     icon: 'GridIcon',
    //     resource: 'Client',
    //     action: 'read',
    // },
    // {
    //     title: 'Producenter',
    //     route: 'brands',
    //     icon: 'BriefcaseIcon',
    //     resource: 'Client',
    //     action: 'read',
    // },

    {
        title: "Indstillinger",
        icon: 'SettingsIcon',
        children: [
            {
                title: 'Butikker',
                route: 'stores',
                icon: 'InfoIcon',
                resource: 'Client',
                action: 'read',
            },
        ],
    },


    {
        title: 'Brugere',
        route: 'users',
        icon: 'KeyIcon',
        resource: 'Admin',
        action: 'manage',
    },

    {
        title: 'Etiketter',
        route: 'labels',
        icon: 'PrinterIcon',
        resource: 'Client',
        action: 'read',
    },
]
